import { render, staticRenderFns } from "./DeliveryExportModal.vue?vue&type=template&id=b4aeff10"
import script from "./DeliveryExportModal.vue?vue&type=script&lang=ts"
export * from "./DeliveryExportModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports